import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getToken, login } from "../../api/client";
import "./login.scss";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [noticeMessage, setNoticeMessage] = useState(location.state?.notice || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  React.useEffect(() => {
    if (getToken()) {
      navigate("/admin", { replace: true });
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMessage("Please enter username and password.");
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");
    setNoticeMessage("");

    try {
      await login(username.trim(), password);
      navigate("/admin", { replace: true });
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand" aria-label="Hin Ho Lee Trading Sdn. Bhd.">
          <span>興和利貿易有限公司</span>
          <strong>Hin Ho Lee Trading Sdn. Bhd.</strong>
        </div>

        <h1 className="login-page__title">Admin Portal</h1>
        <p className="login-page__subtitle">Sign in to manage the Hin Ho Lee storefront</p>

        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__field">
            <span className="login-page__icon">
              <Icon icon="ph:user-fill" height={18} />
            </span>
            <input
              className="login-page__input"
              type="text"
              placeholder="Email"
              value={username}
              autoComplete="username"
              onChange={(e) => {
                setUsername(e.target.value);
                setErrorMessage("");
                setNoticeMessage("");
              }}
            />
          </div>

          <div className="login-page__field">
            <span className="login-page__icon">
              <Icon icon="ph:lock-fill" height={18} />
            </span>
            <input
              className="login-page__input"
              type="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorMessage("");
                setNoticeMessage("");
              }}
            />
          </div>

          {noticeMessage && (
            <div className="login-page__message login-page__message--success">
              {noticeMessage}
            </div>
          )}

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          <button type="submit" className="login-page__submit" disabled={isSubmitting}>
            {isSubmitting ? "Signing in..." : "Login"}
          </button>

          <p className="login-page__link-row">
            <Link className="login-page__link" to="/forgot-password">
              Forgot password?
            </Link>
          </p>
        </form>
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default LoginPage;
